import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { LOCALE_OPTIONS, DEFAULT_LOCALE } from '../i18n/constants';
import './LanguageSelector.css';
const LanguageSelector = () => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [showEmoji, setShowEmoji] = useState(false);
    const selectorRef = useRef(null);
    const languages = LOCALE_OPTIONS;
    const handleLanguageChange = (languageCode) => {
        i18n.changeLanguage(languageCode);
        setIsOpen(false);
    };
    const currentLangCode = (i18n.language || '').split(/[-_]/)[0]?.toLowerCase();
    const currentLanguage = languages.find((lang) => lang.code === currentLangCode) ??
        languages.find((lang) => lang.code === DEFAULT_LOCALE) ??
        languages[0];
    // Emoji-Anzeige nur auf Plattformen/Browsers, die Flaggen gut unterstützen
    useEffect(() => {
        try {
            const ua = window.navigator.userAgent || '';
            const platform = window.navigator.platform || '';
            const isWindows = /Win/i.test(platform) || /Windows/i.test(ua);
            const isChromium = /Chrome/i.test(ua) || /Edg\//i.test(ua);
            const isFirefox = /Firefox/i.test(ua);
            const isMobile = /Android|iPhone|iPad|iPod/i.test(ua);
            // Auf Windows-Chromium (Chrome/Edge) keine Flaggen, sonst schon
            if (!isWindows || isFirefox || isMobile) {
                setShowEmoji(true);
            }
            else {
                setShowEmoji(false);
            }
        }
        catch {
            setShowEmoji(false);
        }
    }, []);
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectorRef.current && !selectorRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isOpen]);
    return (_jsxs("div", { className: "language-selector", ref: selectorRef, children: [_jsxs("button", { className: "current-language", onClick: () => setIsOpen(!isOpen), "aria-expanded": isOpen, "aria-haspopup": "true", children: [showEmoji ? (_jsx("span", { className: "flag-emoji", "aria-hidden": "true", children: currentLanguage.emoji })) : (_jsx("span", { className: "flag-badge", children: currentLanguage.countryCode })), _jsx("span", { className: "name", children: currentLanguage.name })] }), isOpen && (_jsx("div", { className: "language-dropdown", children: languages.map((language) => (_jsxs("button", { className: `language-option ${currentLangCode === language.code ? 'active' : ''}`, onClick: () => handleLanguageChange(language.code), children: [showEmoji ? (_jsx("span", { className: "flag-emoji", "aria-hidden": "true", children: language.emoji })) : (_jsx("span", { className: "flag-badge", children: language.countryCode })), _jsx("span", { className: "name", children: language.name })] }, language.code))) }))] }));
};
export default LanguageSelector;
